<div class="copo-datacenter-filter">
	<label class="filter-number-label" for="filter-text-input">{{this.header}}</label>
	<mat-form-field appearance="outline" class="copo-no-error-message filter-datacenter-text-container">
		<input matInput id="filter-text-input" type="text" spellcheck="false" autocomplete="off" [formControl]="searchTextControl" [placeholder]="this.header + '...'">
		<button type="button" *ngIf="searchTextControl.value" matSuffix mat-icon-button (click)="resetText()" tabindex="-1">
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</mat-form-field>
</div>
